<template>
    <div>
        <b-row role="alert">
            <b-col>
                <div class="sr-only hidden" v-if="isLoading">Pending Applications Loading, Please Wait...</div>
            </b-col>
        </b-row>
        <b-table hover small responsive show-empty class="sr-caption"
            aria-live="polite"
            :id="slug"
            :fields="fields"
            :items="items"
            primary-key="id"
            :busy="isLoading"
            label-sort-asc=""
            label-sort-desc=""
            caption="Pending Application table.  To sort the data in this table by a specific column,
                go to the appropriate column header cell and use enter to sort the data ascending.
                Use enter again to sort descending.">
            <template v-slot:cell(actions)="row">
            
                <b-button size="sm" @click="launchReview(row.item)" 
                    variant="primary"
                    class="mr-1" v-if="!isFinance">
                review
                </b-button>
                <b-button size="sm" @click="launchFinanceScreen(row.item)"
                          variant="primary"
                          class="mr-1" v-if="isFinance">
                    view
                </b-button>
                
            </template>
            <template v-slot:cell(pendingApplication)="data">
                {{ data.item.pendingApplication ? "Yes" : "No" }}
            </template>

            
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>

            <template v-slot:empty="scope">
                <p>No applications found for this work queue.</p>
            </template>

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"
                           label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
                <strong>Loading, Please Wait...</strong>
            </div>  
        </b-table>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    components: {
    },
    props: {
        items: Array,
        slug: [String],
        isLoading: Boolean,
    },
    data: () => ({
        fields: [
            {key: 'receivedDate', sortable: true, label: 'Date Received'},
            {key: 'formattedType', sortable: true, label: 'Type'},
            {key: 'formattedCategory', sortable: true, label: 'License Category'},
            {key: 'licenseNbr', sortable: true, label: 'License #'},
            {key: 'fullName', sortable: true, label: 'Licensee Name'},
            {key: 'paymentStatus', sortable: true, label: 'Payment Status'},
            {key: 'screeningStatus', sortable: true, label: 'I&E Status'},
            {key: 'affirmationStatus', sortable: true, label: 'Supervisor Status'},
            {key: 'edited', sortable: true, label: 'Reopened/Resubmitted'},
            {key: 'actions', label: 'Actions'}
        ],
    }),

    methods: {
        launchReview(item) {
            var toPage = item.applicationType === "Initial" ? 'initial' : 'renew'
            this.$router.push({ name: toPage, params: { id: item.applicationId } })
        },

        isInRenewalPeriod(item) {
            if (item.status === 'ACTIVE' && item.pendingApplication === false) {
                
                const a = moment().add(1, 'months')
                const b = moment(item.expirationDate)
                return b <= a
            } else {
                return false
            }
        },

        launchFinanceScreen(item) {
            this.$router.push({ name: 'finance-screen', params: { id: item.applicationId } })
        },
    },
    computed: {
        isFinance() {
            if (this.$keycloak) {
                return this.$keycloak.hasResourceRole('finance-staff')
            } else {
                return false;
            }
        }
    },
}
</script>
<style>
.paCol { width: 15%; }
</style>